import { TabItemCombinedProps } from './types';

const usePresenter = (props: TabItemCombinedProps): TabItemCombinedProps => {
  return props;
};

export default usePresenter;
